// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root___Tzi-","errors":"Errors_errors__1yIID"};